import {Card, Typography} from "@material-tailwind/react";
import {setMoney} from "../../utils/shared";

const TABLE_HEAD = ["No. venta", "Cliente", "Fecha", "Hora", "Total"];

export function RecentOrders({tableRows}) {
  const sortedAndLimitedRows = [...tableRows]?.sort((a, b) => new Date(b?.creation_date) - new Date(a?.creation_date))?.slice(0, 5);
  return (
    <Card className="h-full w-full rounded-lg p-4" style={{flexBasis: '150px !important'}}>
      <div>
        <Typography
          variant="h4"
          color="black"
          className="mb-1">
          Ventas recientes
        </Typography>
        <Typography
          variant="small"
          color="black"
          className="leading-none opacity-70 mb-6 pl-1"
        >
          Las ventas ultimas {sortedAndLimitedRows?.length} ventas de este mes.
        </Typography>
      </div>
      <div className="w-full overflow-x-scroll">
        <table className="w-full min-w-max table-auto text-left ">
          <thead>
          <tr>
            {TABLE_HEAD.map((head, index) => {
              const isLast = index === TABLE_HEAD.length - 1;
              const classes = isLast ? "text-center" : "";

              return (
                <th
                  key={head}
                  className={`border-b border-blue-gray-100 px-4 py-3`}
                >
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className={`font-normal leading-none opacity-70 ${classes}`}
                  >
                    {head}
                  </Typography>
                </th>
              )
            })
            }
          </tr>
          </thead>
          <tbody>
          {sortedAndLimitedRows?.map(({nit, id, creation_date, total}, index) => {
            const isLast = index === sortedAndLimitedRows.length - 1;
            const classes = isLast ? "px-4 py-2" : "px-4 py-1 border-b border-blue-gray-50";

            return (
              <tr key={creation_date + index}>
                <td className={classes}>
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className="font-normal"
                  >
                    {id}
                  </Typography>
                </td>
                <td className={classes}>
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className="font-normal"
                  >
                    {nit}
                  </Typography>
                </td>
                <td className={classes}>
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className="font-normal"
                  >
                    {new Date(creation_date).toLocaleDateString('es-ES', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    })}
                  </Typography>
                </td>
                <td className={classes}>
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className="font-normal"
                  >
                    {new Date(creation_date).toLocaleTimeString('es-ES', {
                      hour: '2-digit',
                      minute: '2-digit',
                      second: '2-digit',
                    })}
                  </Typography>
                </td>

                <td className={classes}>
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className="font-normal text-black text-right pr-6"
                  >
                    {setMoney(total)}
                  </Typography>
                </td>
              </tr>
            );
          })}
          </tbody>
        </table>
      </div>
    </Card>
  );
}